module.exports = __webpack_public_path__ + "img/concrete_beige_ba_list.9ebcc24e.jpg";